import { StorageFactory } from '../../../storageFactory'
import Vue from 'vue'

import { populatePackages, getInstitutionInfo, getInstitutionDetails, getPublicInstitutionDetails, getInstitutionPackages,
  saveInstitution, getInstitutionLabels, getEmployerJobCount, updateEmployerMappingStatus, deleteMultipleEmployerMapping, addMultipleEmployerMapping, searchEmployersByTitle, searchAssociatedEmployersByTitle,searchInstitutionsByTitle, deleteInstitutionObject, createNewInstitution,
  generateWidgetKeyAndSecret, getWidgetDetail, deleteWidgetKeyAndSecret, getPackageFeatures, logSegmentActivity, logDashboardActivity,
  getApiConfigs, generateOrEditApiConfig, deleteMultipleApiConfigs, getUserReports, getUserReportsByRole,
  getEmailCampaignList, createEmailCampaign, getInstitutionTermMap, updateWidgetKeyAndSecret, searchPreCuratedInstitutionsByName,
  doCsvUploadForPreCuratedInstitution, deletePreCuratedInstitutionObject, postSaveWidgetDetails, getInstitutionInfoPackages,
  getAllAvailableInstitutions, getPartnerInstitutions, getTermsGradesAndCategoriesFromInstitution, getInstitutionMetaInfo,
  generateSelfRegistrationLink, getInstitutionPaymentGateway, getStripeConnectUrl, getInstitutionProducts, putCreateInstitutionProduct,
  putDeleteInstitutionProduct, deleteInstitutionProduct, getInstitutionPricingPlans, putCreateInstitutionPricingPlan, deleteInstitutionPricingPlan,
  putAssignProgramGuide, putDeleteAssignmentProgramGuide, getInstitutionMetaInfoForSelfRegistration, deleteSelfRegistrationLink,
  getSelfRegistrationConfiguration, updateSelfRegistrationConfiguration, putCreateInstitutionCouponCode, deleteInstitutionCouponCode,
  getInstitutionCouponCodes, manageAssociatedEmployersByTitle, searchAssociatedInstitutionsByTitle, getEmployerOrgInfo, updateEmployerOrgDetails as putUpdateEmployerOrgDetails, triggerCourseAggProgressReport, triggerTestPrepProgressReport, downloadLearnerLocationAsCsvFile, doShareFolders, getSharableFolders, triggerItemAnalysisReport, downloadCRAsCsvFile, putSaveInstitutionCouponCode, getAssociatedInstitutionDetail, getInstitutionTransactions, putRefundTransaction,downloadAnswersAsCsvFile ,downloadLearnerReportAsCsvFile} from '../api'

export const storageFactory = () => {
  return StorageFactory(() => localStorage)
}

/* LOAD ALL PACKAGES */
export const loadPackages = ({ state, commit }) => {
  return populatePackages().then(data => {
    commit('LOAD_ALL_PACKAGES', data)
    return data
  })
}

export const loadUserReports = ({ state, commit }) => {
  return getUserReports().then(data => {
    return data
  })
}

export const loadUserReportsByRole = ({ state, commit }, {role, userUuid}) => {
  return getUserReportsByRole(role, userUuid).then(data => {
    return data
  })
}
export const loadSharableFolders = ({ state, commit }) => {
  return getSharableFolders()
}
export const shareFolders = ({ state, commit }, {insId, sharedFolderUuids}) => {
  return doShareFolders(insId, sharedFolderUuids)
}

export const loadInstitutionInfo = ({ state, commit }, { token, uuid }) => {
  var stateInstitution = state.institution
  if(stateInstitution && stateInstitution.uuid===uuid){
    return stateInstitution
  }
  return getInstitutionInfo(token, uuid).then(data => {
    commit('LOAD_INSTITUTION', data)
    return data
  })
}

export const loadInstitutionInfoPackage = ({ state, commit }, { token, uuid }) => {
  return getInstitutionInfoPackages(token, uuid, false).then(packageList => {
    if (packageList !== undefined) {
      commit('LOAD_PACKAGES', packageList)
      let enabledFeatures = {}
      packageList.forEach(packageObj => {
        let features = packageObj.features || []
        features.forEach((feature) => {
          enabledFeatures[feature.featureId] = feature
        })
      })
      commit('LOAD_ENABLED_FEATURES', enabledFeatures)
    }
    return packageList
  })
}

export const loadInstitutionDetail = ({ state, commit }, uuid) => {
  let localStore = storageFactory()
  let institutionId = uuid || localStore.getItem('institutionId')
  if(!institutionId){
    let userobject = localStore.getItem('userobj')
    if(userobject) {
          try{
            institutionId = JSON.parse(userobject).institutionId
          }catch (error) {
            console.log('institutionId not defined')
          }
    }
  }
  var stateInstitution = state.institution
  if(stateInstitution && stateInstitution.uuid===institutionId){
    return stateInstitution
  }
  return getInstitutionDetails(institutionId).then(data => {
    if (data !== undefined) {
      commit('LOAD_INSTITUTION', data)
      commit('LOAD_SELF_REGISTRATION_LINK', data.selfRegistrationLink)
      if(data.selfRegistrationLink){
        let selfSigninLink = data.selfRegistrationLink.replace('signup','signin')
        commit('LOAD_SELF_SIGNIN_LINK', selfSigninLink)
      }
      loadInstitutionLabels({ state, commit }, data.openId)
      // commit('LOAD_PACKAGES', data.packages)
    }
    return data
  })
}

export const loadInstitutionOnlyDetail = ({ state, commit }, uuid) => { 
  var stateInstitution = state.institution
  if(stateInstitution && stateInstitution.uuid===uuid){
    return stateInstitution
  }
  return getInstitutionDetails(uuid).then(data => {
    return data
  })
}

export const loadAssociatedInstitutionDetail = ({ state, commit }) => {
  return getAssociatedInstitutionDetail().then(data => {
    if (data !== undefined) {
      commit('LOAD_ASSOCIATED_INSTITUTIONS', data)
    }
    return data
  })
}

export const loadPublicInstitutionDetail = ({ state, commit }) => {
  let localStore = storageFactory()
  let uuid = localStore.getItem('institutionId')
  if (!uuid) {
    uuid = JSON.parse(localStore.getItem('userobj')).institutionId
  }
  if (uuid) {
    return getPublicInstitutionDetails(uuid).then(data => {
      if (data !== undefined) {
        commit('LOAD_PUBLIC_INSTITUTION', data)
        // commit('LOAD_PACKAGES', data.packages)
      }
      return data
    })
  }
}
/* LOAD PACKAGES FOR A GIVEN INSTITUITION */
export const loadInstitutionPackage = ({ state, commit }, {uuid, isAggregated}) => {
  let localStore = storageFactory()
  let institutionId = uuid || localStore.getItem('institutionId') || JSON.parse(localStore.getItem('userobj')).institutionId
  return getInstitutionPackages(institutionId, isAggregated).then(packageList => {
    if (packageList !== undefined) {
      commit('LOAD_PACKAGES', packageList)
      let enabledFeatures = {}
      packageList.forEach(packageObj => {
        let features = packageObj.features || []
        features.forEach((feature) => {
          enabledFeatures[feature.featureId] = feature
        })
      })
      commit('LOAD_ENABLED_FEATURES', enabledFeatures)
    }
    return packageList
  })
}

export const createInstitution = ({ state, commit }, {institutionData, ownerId}) => {
  return createNewInstitution(institutionData, ownerId).then((response) => {
    commit('LOAD_INSTITUTION', response)
    return response
  })
}

// NOTE: Ensure institutionData.packages are populated before calling this function
export const storeInstitution = ({ state, commit }, institutionData) => {
  return saveInstitution(institutionData).then((response) => {
    commit('LOAD_INSTITUTION', response)
    return response
  })
}

export const loadInstitutionLabels = ({ state, commit }, openId) => {
  return getInstitutionLabels(openId).then((response) => {
    commit('LOAD_INSTITUTION_LABELS', response)
    return response
  })
}

export const searchInstitutions = ({ state, commit }, {page, count, title}) => {
  return searchInstitutionsByTitle(page, count, title).then(res => {
    return res
  })
}
export const searchEmployers = ({ state, commit }, {page, count, title}) => {
  return searchEmployersByTitle(page, count, title).then(res => {
    return res
  })
}
export const searchAssociatedEmployers = ({ state, commit }, {page, count, title}) => {
  return searchAssociatedEmployersByTitle(page, count, title).then(res => {
    return res
  })
}
export const manageAssociatedEmployers = ({ state, commit }, {page, count, title}) => {
  return manageAssociatedEmployersByTitle(page, count, title).then(res => {
    return res
  })
}

export const searchAssociatedInstitutions = ({ state, commit }, {page, count, title}) => {
  return searchAssociatedInstitutionsByTitle(page, count, title).then(res => {
    return res
  })
}

export const deleteEmployerMapping = ({ state, commit }, {institutionId, idsForDelete}) => {
  return deleteMultipleEmployerMapping(institutionId, idsForDelete)
}
export const addEmployerMapping = ({ state, commit }, {institutionId,idsForAdd}) => {
  return addMultipleEmployerMapping(institutionId, idsForAdd)
}
export const updateEmployerMapping = ({ state, commit }, {institutionId, employerId, status, spotlightEmployer}) => {
  return updateEmployerMappingStatus(institutionId, employerId, status, spotlightEmployer)
}

export const getAllEmployerJobCount = ({ state, commit }) => {
  return getEmployerJobCount()
}

export const searchPreCuratedInstitutions = ({ state, commit }, {page, count, name}) => {
  return searchPreCuratedInstitutionsByName(page, count, name).then(res => {
    return res
  })
}

export const deleteInstitution = ({ state, commit }, uuid) => {
  return deleteInstitutionObject(uuid).then(res => {
    return res
  })
}

export const deletePreCuratedInstitution = ({ state, commit }, uuid) => {
  return deletePreCuratedInstitutionObject(uuid).then(res => {
    return res
  })
}

export const loadGenerateWidgetKeyAndSecret = ({ state, commit }, {uuid, type}) => {
  return generateWidgetKeyAndSecret(uuid, type).then(res => {
    return res
  })
}

export const loadWidgetDetail = ({ state, commit }, {uuid, type}) => {
  return getWidgetDetail(uuid, type).then(res => {
    return res
  })
}

export const loadDeleteWidgetKeyAndSecret = ({ state, commit }, uuid) => {
  return deleteWidgetKeyAndSecret(uuid)
}

export const loadUpdateWidgetKeyAndSecret = ({ state, commit }, widget) => {
  return updateWidgetKeyAndSecret(widget)
}

export const loadApiConfigs = ({ state, commit }, { uuid, page, count }) => {
  return getApiConfigs(uuid, page, count)
}

export const loadGenerateOrEditApiConfig = ({ state, commit }, apiConfig) => {
  return generateOrEditApiConfig(apiConfig)
}

export const loadSaveWidgetDetails = ({ state, commit }, widget) => {
  return postSaveWidgetDetails(widget)
}

export const deleteApiConfigs = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleApiConfigs(itemsToDelete)
}

export const loadFeaturesByPackageId = ({ state, commit }, packageId) => {
  return getPackageFeatures(packageId)
}

export const loadEmailCampaignList = ({ state, commit }) => {
  return getEmailCampaignList()
}

export const loadCreateEmailCampaign = ({ state, commit }, emailCampaignObj) => {
  return createEmailCampaign(emailCampaignObj)
}

export const loadInstitutionTermMap = ({ state, commit }, { uuid, excludePastCutOff }) => {
  return getInstitutionTermMap(uuid, excludePastCutOff).then(data => {
    commit('LOAD_INSTITUTION_TERM_MAP', data)
    return data
  })
}

export const uploadPreCuratedInstitutionCsvFile = ({ state, commit }, data) => {
  return doCsvUploadForPreCuratedInstitution(data)
}

export const loadAllAvailableInstitutions = ({ state, commit }) => {
  return getAllAvailableInstitutions()
}

export const loadPartnerInstitutions = ({ state, commit }, includeSelf) => {
  return getPartnerInstitutions(includeSelf).then(res => {
    commit('LOAD_PARTNER_INSTITUTIONS', res)
    return res
  })
}

export const loadTermsGradesAndCategoriesFromInstitution = ({ state, commit }) => {
  return getTermsGradesAndCategoriesFromInstitution()
}

export const loadInstitutionMetaInfo = ({ state, commit }) => {
  return getInstitutionMetaInfo()
}
export const loadEmployerOrgInfo = ({ state, commit }, employerId) => {
  return getEmployerOrgInfo(employerId)
}
export const updateEmployerOrgDetails = ({ state, commit }, {employerId, employer}) => {
  return putUpdateEmployerOrgDetails(employerId, employer)
}
export const loadGenerateSelfRegistrationLink = ({ state, commit }, uuid) => {
  return generateSelfRegistrationLink(uuid).then(link => {
    commit('LOAD_SELF_REGISTRATION_LINK', link[0])
    commit('LOAD_SELF_SIGNIN_LINK', link[1])
    return link
  })
}

export const loadDeleteSelfRegistrationLink = ({ state, commit }, uuid) => {
  return deleteSelfRegistrationLink(uuid).then(resp => {
    commit('LOAD_SELF_REGISTRATION_LINK', null)
    commit('LOAD_SELF_SIGNIN_LINK', null)
    return resp
  })
}

export const loadInstitutionMetaInfoForSelfRegistration = ({ state, commit }, uuid) => {
  return getInstitutionMetaInfoForSelfRegistration(uuid)
}

export const loadSelfRegistrationConfiguration = ({ state, commit }, uuid) => {
  return getSelfRegistrationConfiguration(uuid)
}

export const storeSelfRegistrationConfiguration = ({ state, commit }, {uuid, data}) => {
  return updateSelfRegistrationConfiguration(uuid, data)
}

export const loadLogDashboardActivity = ({ state, commit }, {action, page, link, entityUuid, programCipCode, careerSocCode, programCode, preLoginInstitutionId, preLoginInstitutionName, preUser, stripeError,programName, programgDescription,thumbnailURL, programPrice}) => {
  let ua = window.navigator.userAgent
  let browserName = ''
  let browserVersion = ''
  try {
    var tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      browserName = 'IE'
      browserVersion= tem[1]
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
      if (tem != null && tem.length > 1) {
        browserName = tem[1].replace("OPR", "Opera")
        browserVersion= tem[2]
      } else {
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
        browserName = M[0]
        browserVersion = M[1]
      }
    } else {
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
      browserName = M[0]
      browserVersion = M[1]
    }
  } catch (e) {
    console.log('Couldnt compute browser information')
  }

  let localStore = storageFactory()
  let uObj = JSON.parse(localStore.getItem('userobj'))
  if(!uObj){
    uObj = (preUser?preUser:{})
  }
  let role = localStore.getItem('userrole')
  let institution = localStore.getItem('institution')
  if(!institution){
    institution = preLoginInstitutionName
  }
  let institutionId = uObj.institutionId
  if(!institutionId){
    institutionId = preLoginInstitutionId
  }
  let token = (localStore.getItem('token')?localStore.getItem('token'):'')
  let currentTime = (new Date()).getTime()
  let data = '&action=' + action +
             '&userUuid=' + uObj.uuid +
             '&userFirstName=' + uObj.firstName +
             '&userLastName=' + uObj.lastName +
             '&userEmail=' + uObj.eMail +
             '&userRole=' + role +
             '&institutionName=' + institution +
             '&institutionUuid=' + institutionId +
             '&studentType=' +
             '&advisor=' +
             '&major=' + uObj.major1Title +
             '&concentration=' + uObj.concentration1Title +
             '&minor=' + uObj.minor1Title +
             '&product=' +
             '&productPackage=' +
             '&productArea=' +
             '&page=' + page +
             '&link=' + link +
             '&MajorCIP=' +
             '&GPA=' + uObj.majorGpa +
             '&MajorGPA=' + uObj.overallGpa +
             '&entityUuid=' + entityUuid +
             '&programCipCode=' + programCipCode +
             '&programCode=' + programCode +
             '&careerSocCode=' + careerSocCode +
             '&recordedTime=' + currentTime +
             '&utm_medium=' + localStore.getItem('utm_medium') +
             '&utm_source=' + localStore.getItem('utm_source') +
             '&utm_campaign=' + localStore.getItem('utm_campaign') +
             '&utm_content=' + localStore.getItem('utm_content') +
             '&utm_term=' + localStore.getItem('utm_term') +
             '&browser=' + browserName +
             '&browserVersion=' + browserVersion +
             '&userAgent=' + ua +
             '&stripeError=' + stripeError
            if(localStore.getItem('inpersonatingUser')){
              data += '&inpersonatingUser=' + localStore.getItem('inpersonatingUser')
              data += '&inpersonatingUserName=' + localStore.getItem('inpersonatingUserName')
            }
      let response = logDashboardActivity(data, token)
      logSegmentActivity(uObj, role, action, institution, institutionId, page, link,programName, programgDescription,thumbnailURL, programPrice)
  return response
}

export const loadInstitutionPaymentGateway = ({ state, commit }) => {
  return getInstitutionPaymentGateway()
}

export const loadStripeConnectUrl = ({ state, commit }) => {
  return getStripeConnectUrl()
}

export const loadInstitutionProducts = ({ state, commit }) => {
  return getInstitutionProducts()
}

export const loadCreateInstitutionProduct = ({ state, commit }, institutionProductObj) => {
  return putCreateInstitutionProduct(institutionProductObj)
}

export const loadDeleteInstitutionProduct = ({ state, commit }, institutionProductId) => {
  return deleteInstitutionProduct(institutionProductId)
}

export const loadInstitutionPricingPlans = ({ state, commit }) => {
  return getInstitutionPricingPlans()
}

export const loadCreateInstitutionPricingPlan = ({ state, commit }, institutionPricingPlanObj) => {
  return putCreateInstitutionPricingPlan(institutionPricingPlanObj)
}

export const loadDeleteInstitutionPricingPlan = ({ state, commit }, institutionPricingPlanId) => {
  return deleteInstitutionPricingPlan(institutionPricingPlanId)
}

export const loadPutAssignProgramGuide = ({ state, commit }, {institutionPricingPlanId, programGuides}) => {
  return putAssignProgramGuide(institutionPricingPlanId, programGuides)
}

export const loadPutDeleteAssignmentProgramGuide = ({ state, commit }, {institutionPricingPlanId, programGuides}) => {
  return putDeleteAssignmentProgramGuide(institutionPricingPlanId, programGuides)
}

export const loadRefundTransaction = ({ state, commit }, {transactionId, refundObj}) => {
  return putRefundTransaction(transactionId, refundObj)
}

export const loadInstitutionTransactions = ({ state, commit }, {page, count}) => {
  return getInstitutionTransactions(page, count)
}

export const loadInstitutionCouponCodes = ({ state, commit }) => {
  return getInstitutionCouponCodes()
}

export const loadCreateInstitutionCouponCode = ({ state, commit }, institutionCouponCodeObj) => {
  return putCreateInstitutionCouponCode(institutionCouponCodeObj)
}

export const loadDeleteInstitutionCouponCode = ({ state, commit }, institutionCouponCodeId) => {
  return deleteInstitutionCouponCode(institutionCouponCodeId)
}

export const loadSaveInstitutionCouponCode = ({ state, commit }, {couponCodeId, couponCodeObj}) => {
  return putSaveInstitutionCouponCode(couponCodeId, couponCodeObj)
}

export const downloadAnswersAsCsv = ({ state, commit }) => {
  return downloadAnswersAsCsvFile().then(response => {
    return response
  })
}
export const downloadCRAsCsv = ({ state, commit }, type) => {
  return downloadCRAsCsvFile(type).then(response => {
    return response
  })
}

export const downloadLearnerReport = ({ state, commit }) => {
  return downloadLearnerReportAsCsvFile().then(response => {
    return response
  })
}
export const downloadLearnerLocationReport = ({ state, commit }, flag) => {
  return downloadLearnerLocationAsCsvFile(flag).then(response => {
    return response
  })
}
export const sendTestPrepProgressReport = ({ state, commit }) => {
  return triggerTestPrepProgressReport().then(response => {
    return response
  })
}
export const sendCourseAggProgressReport = ({ state, commit }, {startDate, endDate, email}) => {
  return triggerCourseAggProgressReport(startDate, endDate, email).then(response => {
    return response
  })
}

export const sendItemAnalysisReport = ({ state, commit }) => {
  return triggerItemAnalysisReport().then(response => {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/institution/vuex/actions.js